<template>
  <div class="box full">
    <div class="box-header">
      Alerts
    </div>
    <div class="box-content-block pt-4">
      <template v-if="!loading">
        <div>
          <div class="relative">
            <button
              v-if="openedAlert !== ''"
              class="btn-dark-button absolute right-2 top-2"
              @click="openedAlert = ''"
            >
              Close (Q)
            </button>
            <AlertModal
              :value="openedAlert !== ''"
              @closedAlert="openedAlert = ''"
              :alertId="openedAlert"
            />
            <div v-show="openedAlert == ''">
              <div v-if="alerts && alerts.length > 0">
                <AlertsTable
                  v-if="alerts.length > 0"
                  :filters="filters"
                  :alerts="alerts"
                  :openedAlert="openedAlert"
                  @open="open"
                  @hideAlert="hideAlert"
                  @unhideAlert="unhideAlert"
                ></AlertsTable>
              </div>
              <div v-else-if="!loading">
                No alerts found
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <BaseLoading :loading="true"></BaseLoading>
      </template>
    </div>
  </div>
</template>
<script>
import AlertsTable from "@/components/alerts/AlertsTable.vue";
import AlertModal from "@/components/alerts/AlertModal.vue";
import {
  getAlerts,
  hideAlert as hideAlertApi,
  unhideAlert as unhideAlertApi
} from "@/api/masterAdmin/AlertsService.js";
export default {
  name: "ProductsSoldTogether",
  components: {
    AlertsTable,
    AlertModal
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      alerts: [],
      filters: {
        nkr_code: this.code,
        hidden: 0
      },
      openedAlert: ""
    };
  },
  mounted() {
    this.loadAlerts();
  },
  methods: {
    loadAlerts() {
      this.loading = true;
      this.alerts = [];
      const filters = {
        nkr_code: this.code,
        hidden: 0
      };
      getAlerts(filters)
        .then(response => {
          this.alerts = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(customerID) {
      this.openedAlert = customerID;
    },
    async hideAlert(id) {
      try {
        await hideAlertApi(id);
      } catch (error) {
        alert("error hiding alert");
      }
      const found = this.alerts.find(alert => alert.id == id);
      found.hidden = 1;
    },
    async unhideAlert(id) {
      try {
        await unhideAlertApi(id);
      } catch (error) {
        alert("error unhiding alert");
      }
      const found = this.alerts.find(alert => alert.id == id);
      found.hidden = 0;
    }
  }
};
</script>
